<section class="landing-inversores__hero">
  <div class="landing-inversores__container landing-inversores__hero-grid">
    <div>
      <span class="landing-inversores__hero-badge">
        <landing-inversores-icon name="lock"></landing-inversores-icon>
        Oportunidades en exclusiva
      </span>

      <h1 class="landing-inversores__hero-title">Compra pisos alquilados con rentabilidad verificada.</h1>

      <p class="landing-inversores__hero-lead">
        Firma tu próxima inversión en menos de 40 días. Más de 400 propiedades con análisis financiero real: yield,
        flujo de caja y estado del inquilino auditado por arquitecto.
      </p>

      <div class="landing-inversores__hero-pills">
        <span class="landing-inversores__hero-pill">
          <landing-inversores-icon name="zap"></landing-inversores-icon>
          Cierre en menos de 40 días
        </span>
        <span class="landing-inversores__hero-pill">
          <landing-inversores-icon name="pen"></landing-inversores-icon>
          Firma de reserva y arras 100% online
        </span>
      </div>

      <ul class="landing-inversores__hero-bullets">
        <li *ngFor="let b of bullets">
          <span class="landing-inversores__hero-check">
            <landing-inversores-icon name="check"></landing-inversores-icon>
          </span>
          <span><strong>{{ b.strong }}</strong> {{ b.rest }}</span>
        </li>
      </ul>

      <div class="landing-inversores__hero-cta-row">
        <a
          class="landing-inversores__button landing-inversores__button--large landing-inversores__button--primary"
          [href]="advisoryBookingUrl"
          target="_blank"
          rel="noopener noreferrer"
        >
          Reserva tu Asesoría Gratuita
        </a>
        <p class="landing-inversores__hero-cta-note">Sin registro. Sin compromiso. Resultados en segundos.</p>
      </div>

      <div class="landing-inversores__hero-images">
        <img
          *ngFor="let src of heroImages; let i = index"
          [src]="src"
          alt="Vivienda Inviertis"
          width="200"
          height="200"
          [attr.loading]="i === 0 ? 'eager' : 'lazy'"
        />
      </div>
    </div>

    <div class="landing-inversores__hero-form-col">
      <landing-inversores-lead-form containerId="landing-inversores-hs-form"></landing-inversores-lead-form>
    </div>
  </div>
</section>
